export enum DeploymentState {
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  ERROR = 'ERROR',
}

export interface DeploymentStatus {
  readonly state: DeploymentState;
  readonly processId: string;
  readonly createdDate: string;
  readonly errorMessage?: string;
  readonly stackTrace?: string;
}

export interface ServerReloadStatus {
  readonly reloadMethod: string;
  readonly createdDate: string;
  readonly success: boolean;
  readonly errorMessage?: string;
}

export interface DeploymentModel {
    readonly id: string;
    readonly serverId: string;
    readonly commitId: string;
    readonly status: DeploymentStatus;
    readonly serverReloads: ServerReloadStatus[];
    readonly author: string;
    readonly createdDate: string;
    readonly lastModifiedDate: string;
}
